module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/toolbar_add_localfile-092b7e.svg";